<template>
  <div class="clearfix" v-if="!loader">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="loader" class="card mb-25 border-0 rounded-0 bg-white letter-spacing" id="back">
    <div 
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          @click="showScreen('excel')"
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"
          v-if="current_permissions('get_transaction')"
        >
          {{ $t('transfers.export') }}
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button 
          type="button"
          class="default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"    
          data-bs-toggle="modal"
          data-bs-target="#generateLink" 
          v-if="current_permissions('create_public_token')"
        >
          {{ $t('transfers.paymentLink') }}
        </button>
      </div>
      <div class="d-sm-flex align-items-center">           
        <div>
          <div class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0">
            <input
              v-model="today"
              type="date"
              class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              id="lead-calendar"
              :placeholder="leadPlaceholder"
              @change="searchTransaction1"
            />
          </div>
        </div>   
        <button style="width:max-content"
          type="button"
          class="default-btn d-block text-center w-100 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25"          
          @click="redirect('/multi-transferts')"
          v-if="current_permissions('init_checkout')"
        >
          {{ $t('transfers.multipleSend') }}
        </button>
        &nbsp; &nbsp; &nbsp;
        <button
          type="button"
          class="d-block text-center w-100 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25"
          data-bs-toggle="modal"
          data-bs-target="#sendMoneyModal"  
          style="background-color: #EB9355;" 
          v-if="current_permissions('init_checkout')"
        >
          {{ $t('transfers.singleSend') }}
        </button>
        <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0  ms-2"
          type="button"   
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"   
          @click="showScreen('search')"   
        >        
          <svg
            width="25"
            height="25"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table id="" class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('transfers.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.beneficiary') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.operator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.phone') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.amount') }}
              </th> 
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.date') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transfers.validation') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(transaction) in transactions" :key="transaction.payoutId">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="form-check mb-0">
                    <span class="badge text-outline-primary">
                      <i class="flaticon-web" v-if="transaction.publicToken!=null" style="font-weight: bold;"></i>
                    </span>
                  </div>
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ transaction.payoutId}}
                  </div>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.clientId}} 
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis" :title="transaction.description">
                {{ transaction.description}}
              </td>              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.operator.mnoName}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.contact}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.amount.toLocaleString()}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatDateFr(new Date(transaction.transactionDate))}}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span :class="getPaymentStatusClass(transaction.paymentStatus)">
                  {{ getPaymentStatusLabel(transaction.paymentStatus) }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-if="transaction.validationStatus==='DRAFT'">{{ $t('transfers.draft') }}</span>
                <span v-else-if="transaction.validationStatus==='VALIDATED'">{{ $t('transfers.validated') }}</span>
                <span v-else-if="transaction.validationStatus==='REJECTED'">{{ $t('transfers.rejected') }}</span>
                <span v-else-if="transaction.publicTokenValidationStatus==='DRAFT'">{{ $t('transfers.draft') }}</span>
                <span v-else-if="transaction.publicTokenValidationStatus==='VALIDATED'">{{ $t('transfers.validated') }}</span>
                <span v-else-if="transaction.publicTokenValidationStatus==='REJECTED'">{{ $t('transfers.rejected') }}</span>
                <span class="badge text-outline-success" v-else-if="transaction.publicTokenValidationStatus==='SUCCEEDED'">{{ $t('transactions.success') }}</span>
                <span class="badge text-outline-danger" v-else-if="transaction.publicTokenValidationStatus==='FAILED'">{{ $t('transactions.failed') }}</span>
                <span class="badge text-outline-info" v-else-if="transaction.publicTokenValidationStatus==='PROCESSING'">{{ $t('transactions.processing') }}</span>
                <span class="badge text-outline-info" v-else-if="transaction.publicTokenValidationStatus==='PENDING'">{{ $t('transactions.pending') }}</span>
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button
                  class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                  type="button"
                  @click="toggleActionMenu($event, transaction.payoutId)"
                >
                  <i class="flaticon-dots"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div id="transactionsTable">
          <p>
            <span id="headerLeftText" class="d-lg-inline-block p-2 text-start">{{ organization_name }} </span>
            <span id="headerRightText" class="d-inline-block p-2 text-end">{{ $t('transfers.editionDate') }} {{ formatDateFr(new Date()) }} </span>
            <span id="headerLeftText" class="d-lg-inline-block p-2 text-start" style="margin-top: -2%;">{{ email }} </span>
          </p>
          <hr />
          <div style="margin-top: 7%;">
            <h2 class="text-center shadow-none lh-1 fw-medium" id="title" style="">{{ $t('transfers.listTitle') }}</h2>
            <h5 class="text-center" id="subtitle">
              {{ $t('transfers.period') }}
              {{ beginDate ? formatDateFr(new Date(beginDate)) : $t('transfers.all') }}
              {{ $t('transfers.to') }}
              {{ endDate ? formatDateFr(new Date(endDate)) : $t('transfers.all') }}
            </h5>
          </div>
          <div style="padding-left: 1%;padding-right: 1%;" class="">
            <table id="tableLayout" class="table" style="margin-right: 1%;">
              <thead>
                <tr>
                  <th class="text-uppercase fw-medium shadow-none tableHeader">{{ $t('transfers.code') }}</th>
                  <th class="text-uppercase fw-medium shadow-none">{{ $t('transfers.operator') }}</th>
                  <th class="text-uppercase fw-medium shadow-none">{{ $t('transfers.phone') }}</th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none">{{ $t('transfers.amount') }}</th> 
                  <th scope="col" class="text-uppercase fw-medium shadow-none">{{ $t('transfers.date') }}</th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none">{{ $t('transfers.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction1) in transaction1s" :key="transaction1.payoutId">
                  <th class="fw-medium">
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                        {{ transaction1.payoutId}}
                      </div>
                    </div>
                  </th>
                  <td class="fw-medium"><span>{{ transaction1.operator.mnoName}}</span></td>
                  <td class="shadow-none lh-1 fw-medium">{{ transaction1.contact}}</td>
                  <td class="shadow-none lh-1 fw-medium"><span>{{ transaction1.amount.toLocaleString()}}</span></td>
                  <td class="shadow-none lh-1 fw-medium">{{ formatDateFr(new Date(transaction1.transactionDate))}}</td>
                  <td class="shadow-none lh-1 fw-medium">
                    {{ getPaymentStatusLabel(transaction1.paymentStatus) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="total>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="total>10" class="mb-0 text-paragraph">
          {{ $t('transfers.showing') }} <span v-if="total>page*10" class="fw-bold">{{ page*10 }}</span> <span v-else class="fw-bold">{{ total }}</span> {{ $t('transfers.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('transfers.results') }}
        </p>
        <p v-if="total<=10" class="mb-0 text-paragraph">
          {{ $t('transfers.showing') }} <span class="fw-bold">{{ total }}</span> {{ $t('transfers.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('transfers.results') }}
        </p>
        <nav v-if="gettran==true" class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="getTransactions(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">              
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="getTransactions(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="getTransactions(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
        <nav v-if="search==true" class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="searchTransaction(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">              
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="searchTransaction(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="searchTransaction(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
        <nav v-if="search1==true" class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="searchTransaction1($event,page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">              
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="searchTransaction1($event,numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="searchTransaction1($event,page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════════════════════ -->
  <!-- MENU D'ACTIONS FLOTTANT (Teleport vers body)                -->
  <!-- ═══════════════════════════════════════════════════════════ -->
  <Teleport to="body">
    <ul
      v-if="openMenuId"
      class="dropdown-menu show action-menu-fixed"
      :style="{ top: menuPosition.top + 'px', left: menuPosition.left + 'px' }"
      @click.stop
    >
      <li>
        <a @click="handleView(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          {{ $t('transfers.view') }}
        </a>
      </li>
      <li>
        <a @click="handleReceipt(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          {{ $t('transfers.downloadReceipt') }}
        </a>
      </li>
      <li v-if="isSuperAdmin">
        <a @click="handleShowStatus(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          Statut réel
        </a>
      </li>
      <li v-if="currentMenuTransaction && currentMenuTransaction.publicToken != null && currentMenuTransaction.validationStatus === 'DRAFT'">
        <a @click="copyToShare(currentMenuTransaction.publicToken)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          {{ $t('transfers.copyLink') }}
        </a>
      </li>
      <li>
        <a target="_blank" class="dropdown-item d-flex align-items-center" href="https://wa.me/message/SV5FPBLDUDCBJ1?text=urlencodedtext" @click="closeActionMenu">
          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
          {{ $t('transfers.claim') }}
        </a>
      </li>
      <li v-if="isSuperAdmin">
        <a @click="handleChangeStatus(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
          Changer statut
        </a>
      </li>
    </ul>
  </Teleport>

  <!-- Modal Send Money -->
  <div class="modal fade" id="sendMoneyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="sendMoney">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('transfers.sendMoney') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div style="margin-bottom: 5%;">
              <h6 class="text-black fw-bold mb-0 text-center">{{ $t('transfers.balance') }}</h6>
              <h6 class="text-black fw-bold mb-0 text-center" style="color: red;">{{ payoutBalance?.toLocaleString()}} XOF</h6>
            </div>    
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">                          
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.phone') }}</label>
                  <div>
                    <input v-model="formValues.contact" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="contact" placeholder="ex: 0500457801" @blur="handlePhone($event.target.value,$event.target)" @focus="initOperator($event.target.value,$event.target)" @keyup="handlePhone($event.target.value,$event.target)" @change="validate('contact')" :class="{ 'is-invalid': errorsBis['contact'] }" />
                    <span class="invalid-feedback">{{ errorsBis['contact']}}</span> 
                  </div>                               
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.operators') }}</label>
                  <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleOperatorChange" required>
                    <option value="">{{ $t('transfers.select') }}</option>                 
                    <option v-for="operator in operators" :value="operator.mnoName" :key="operator.code"> {{ operator.mnoName }}</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.amount') }}</label>              
                  <div>
                    <input
                      v-model="formValues.amount"
                      type="number"
                      min="1"
                      step="1"
                      class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      id="amount"
                      placeholder="2"
                      @keydown="blockInvalidAmountKeys"
                      @keyup="validate_phone_number($event.target.value,$event.target)"
                      @input="sanitizeSendMoneyAmount($event.target.value,$event.target)"
                      @blur="validate('amount')"
                      :class="{ 'is-invalid': errorsBis['amount'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['amount']}}</span> 
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.beneficiary') }}</label>              
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="name" placeholder="Aka Franck" @blur="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span> 
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.category') }}</label>              
                  <select name="business" id="business" class="form-select fs-md-15 text-black shadow-none" @change="handleBusinessChange">
                    <option value="">{{ $t('transfers.select') }}</option>                 
                    <option v-for="businessItem in business" :value="businessItem.code" :key="businessItem.code"> {{ businessItem.name }}</option>
                  </select>
                </div>
                <div class="col-md-4" id="container_sub_business">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.subCategory') }}</label> 
                  <select name="sub_business" id="sub_business" class="form-select fs-md-15 text-black shadow-none" @change="handleSubBusinessChange">
                    <option value="">{{ $t('transfers.selectSubCategory') }}</option>                 
                    <option v-for="subBusinessItem in subBusiness" :value="subBusinessItem.code" :key="subBusinessItem.code"> {{ subBusinessItem.name }}</option>
                  </select>
                </div>
                <div class="col-md-4" v-if="current_permissions('SUPERADMIN')">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.clients') }}</label>              
                  <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" @change="handleOrganizationChange" required>
                    <option value="">{{ $t('transfers.select') }}</option>                 
                    <option v-for="organization in organizations" :value="organization.code" :key="organization.id"> {{ organization.name }}</option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top: 1%;">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.description') }}</label> 
                <div>
                  <textarea v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="description"  @blur="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }"></textarea>
                  <span class="invalid-feedback">{{ errorsBis['description']}}</span> 
                </div>
                <br/>
                <span v-if="businessMessage!=''" class="text-danger">{{ businessMessage}}</span> 
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" :disabled="!btnLoad" v-if="current_permissions('init_checkout')">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              {{ $t('transfers.send') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div> 

  <!-- Modal Filter -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 v-if="screenSelected=='search'" class="modal-title fs-5">{{ $t('transfers.advancedSearch') }}</h1>
          <h1 v-if="screenSelected=='excel'" class="modal-title fs-5">{{ $t('transfers.exportTransactions') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-tabs">
          <button
            type="button"
            class="modal-tab"
            :class="{ active: activeFilterTab === 'base' }"
            @click="activeFilterTab = 'base'"
          >
            Critères de recherche
            <span class="tab-badge" v-if="activeBaseFiltersCount > 0">{{ activeBaseFiltersCount }}</span>
          </button>
          <button
            type="button"
            class="modal-tab"
            :class="{ active: activeFilterTab === 'advanced' }"
            @click="activeFilterTab = 'advanced'"
            v-if="isPrivilegedRole"
          >
            Filtres avancés
            <span class="tab-badge" v-if="activeAdvancedFiltersCount > 0">{{ activeAdvancedFiltersCount }}</span>
          </button>
        </div>

        <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
          <div v-if="errors!==''" style="margin-top: 5%;">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>              
          </div>
          <div class="form-group mb-15 mb-sm-20 mb-md-25">

            <div v-show="activeFilterTab === 'base'">
              <div class="row g-3">
                <div class="col-md-6" v-if="current_permissions('SUPERADMIN')">
                  <label class="d-block text-black fw-semibold mb-10">Organization</label>
                  <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" @change="handleOrganizationChange">
                    <option value="">{{ $t('transfers.select') }}</option>
                    <option v-for="organization in organizations" :value="organization.code" :key="organization.id"> {{ organization.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Operator</label>
                  <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleOperatorChange">
                    <option value="">{{ $t('transfers.select') }}</option>
                    <option v-for="operator in operators" :value="operator.mnoName" :key="operator.code"> {{ operator.mnoName }}</option>
                  </select>
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Status</label>
                  <select name="status" id="status" class="form-select fs-md-15 text-black shadow-none" @change="handleStatusChange">
                    <option value="">{{ $t('transfers.select') }}</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="OPEN">OPEN</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Payment Status</label>
                  <select name="paymentStatus" id="paymentStatus" class="form-select fs-md-15 text-black shadow-none" @change="handlePaymentStatusChange">
                    <option value="">{{ $t('transfers.select') }}</option>
                    <option value="SUCCEEDED">SUCCEEDED</option>
                    <option value="PROCESSING">PROCESSING</option>
                    <option value="PENDING">PENDING</option>
                    <option value="FAILED">FAILED</option>
                    <option value="INITIATED">INITIATED</option>
                    <option value="SCHEDULED">SCHEDULED</option>
                  </select>
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Date Début</label>
                  <input v-model="beginDate" type="date" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Date Fin</label>
                  <input v-model="endDate" type="date" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Amount</label>
                  <input
                    v-model="filterAmount"
                    type="number"
                    min="1"
                    step="1"
                    class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                    placeholder="10"
                    @keydown="blockInvalidAmountKeys"
                    @input="sanitizeFilterAmount($event.target.value,$event.target)"
                  />
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Transaction Date</label>
                  <input v-model="filterTransactionDate" type="datetime-local" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
                </div>
              </div>
            </div>

            <div v-show="activeFilterTab === 'advanced'" v-if="isPrivilegedRole">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Checkout ID</label>
                  <input v-model="filterCheckoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="202401221110522250595736110" />
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">User</label>
                  <input v-model="filterUser" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="35b730c4-ad8e-436e-a2ca-833bb73d47" />
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">Count</label>
                  <input v-model="filterCount" type="number" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="10" />
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">Ordre</label>
                  <select v-model="filterOrder" class="form-select fs-md-15 text-black shadow-none">
                    <option value="">{{ $t('transfers.select') }}</option>
                    <option value="DESC">DESC</option>
                    <option value="ASC">ASC</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">Platform</label>
                  <select v-model="filterPlatform" class="form-select fs-md-15 text-black shadow-none">
                    <option value="">{{ $t('transfers.select') }}</option>
                    <option value="PARTNER">PARTNER</option>
                    <option value="ADMIN">ADMIN</option>
                  </select>
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Phone</label>
                  <input v-model="phone_number" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="0564791896" />
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">Payout ID</label>
                  <input v-model="filterPayoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="01589b-11ec-6bwx2w" />
                </div>
              </div>
            </div>

            <div v-if="screenSelected=='excel' && exportEmpty" class="row" style="margin-top: 2%;">
              <div class="col-12">
                <div class="alert alert-warning mb-0" role="alert">
                  {{ $t('transfers.noResultForExport') }}
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="resetFilters()">
            {{ $t('transfers.refresh') }}
          </button>
          <button v-if="screenSelected=='search'" type="button" class="btn" style="background-color: #EB9355;" data-bs-dismiss="modal" @click="searchTransaction(1)">
            <i class="flaticon-search-interface-symbol" style="color: #FFF;"></i>
          </button>
          <button v-if="screenSelected=='excel'" :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="searchTransactionForExport()">           
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('transfers.excel') }}</span> 
          </button>
          <button v-if="screenSelected=='excel'" :disabled="!btnLoad1" type="button" class="btn" style="background-color: blue;" @click="exportToPDF()">           
            <span v-if="!btnLoad1" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('transfers.pdf') }}</span> 
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Details -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('transactions.transactionDetails') }} ({{ paymentStatus }})</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-tabs">
            <button
              type="button"
              class="modal-tab"
              :class="{ active: activeDetailTab === 'main' }"
              @click="activeDetailTab = 'main'"
            >
              Informations principales
            </button>
            <button
              type="button"
              class="modal-tab"
              :class="{ active: activeDetailTab === 'advanced' }"
              @click="activeDetailTab = 'advanced'"
              v-if="isPrivilegedRole"
            >
              Informations avancées
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">

              <div v-show="activeDetailTab === 'main'">
                <div class="row g-3">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.checkoutId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.transactionCode') }}</label>
                    <input v-model="transaction.checkoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-4"
                       v-if="transaction.paymentStatus==='SUCCEEDED' && hasValue(transaction.operator?.mnoName==='WAVE' ? transaction.providerTransactionId : transaction.providerTransactionReference)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operatorReference') }}</label>
                    <input v-if="transaction.operator?.mnoName!=='WAVE'" v-model="transaction.providerTransactionReference" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                    <input v-if="transaction.operator?.mnoName=='WAVE'" v-model="transaction.providerTransactionId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-4" v-if="hasValue(amount)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.amount') }}</label>
                    <input v-model="amount" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-4" v-if="hasValue(transaction.transactionDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.date') }}</label>
                    <input v-model="transaction.transactionDate" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-4" v-if="hasValue(operator)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operator') }}</label>
                    <input v-model="operator" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-4" v-if="hasValue(transaction.contact)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.phone') }}</label>
                    <input v-model="transaction.contact" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
              </div>

              <div v-show="activeDetailTab === 'advanced'" v-if="isPrivilegedRole">
                <div class="row g-3">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.payoutId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.payoutId') }}</label>
                    <input v-model="transaction.payoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.bulkId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.bulkId') }}</label>
                    <input v-model="transaction.bulkId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.status)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.technicalStatus') }}</label>
                    <input :value="transaction.status" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.validationStatus)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.validationStatus') }}</label>
                    <input :value="transaction.validationStatus" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>

                <div class="row g-3 mt-1">
                  
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.statusCode)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.statusCode') }}</label>
                    <input :value="transaction.statusCode" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.operationType)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operationType') }}</label>
                    <input :value="String(transaction.operationType)==='1' ? $t('transactions.payin') : (String(transaction.operationType)==='2' ? $t('transactions.payout') : transaction.operationType)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.clientId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.clientId') }}</label>
                    <input v-model="transaction.clientId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>

                <div class="row g-3 mt-1">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.currency)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.currency') }}</label>
                    <input v-model="transaction.currency" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.countryCode)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.countryCode') }}</label>
                    <input v-model="transaction.countryCode" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.totalFees)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.totalFees') }}</label>
                    <input :value="transaction.totalFees" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>

                <div class="row g-3 mt-1">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.imoneyFees)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.imoneyFees') }}</label>
                    <input :value="transaction.imoneyFees" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.operatorFees)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operatorFees') }}</label>
                    <input :value="transaction.operatorFees" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.user?.email)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.initiatedByUser') }}</label>
                    <input :value="transaction.user?.email" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>

                <div class="row g-3 mt-1">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.business?.name)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.businessLabel') }}</label>
                    <input :value="transaction.business?.name" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.clientReference)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.clientReference') }}</label>
                    <input v-model="transaction.clientReference" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  
                </div>

                <div class="row g-3 mt-1">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.handlingDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.handlingDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.handlingDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.processingDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.processingDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.processingDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.apiVersion)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.apiVersion') }}</label>
                    <input v-model="transaction.apiVersion" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.finalStateDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.finalStateDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.finalStateDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>

                <div class="row g-3 mt-1">
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.checkingDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.checkingDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.checkingDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                  <div class="col-12 col-md-4" v-if="hasValue(transaction.errorMessage)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.errorMessage') }}</label>
                    <input v-model="transaction.errorMessage" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly style="color: red;" />
                  </div>
                </div>

                <div class="row g-3 mt-1" v-if="hasValue(transaction.description)">
                  <div class="col-12">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.descriptionLabel') }}</label>
                    <textarea :value="transaction.description" rows="2" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly></textarea>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Generate Link -->
  <div class="modal fade" id="generateLink" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">     
      <div class="modal-content">
        <form @submit.prevent="generateLink">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('transfers.paymentLink') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div style="margin-bottom: 5%;">
              <h6 class="text-black fw-bold mb-0 text-center">{{ $t('transfers.balance') }}</h6>
              <h6 class="text-black fw-bold mb-0 text-center" style="color: red;">{{ payoutBalance?.toLocaleString()}} XOF</h6>
            </div>
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-3">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.validationType') }}</label>              
                  <select name="validationType" id="validationType" class="form-select fs-md-15 text-black shadow-none" @change="handleValidationTypeChange" required>
                    <option value="SIMPLE">{{ $t('transfers.simple') }}</option>                 
                    <option value="DOUBLE">{{ $t('transfers.double') }}</option> 
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.amount') }}</label>              
                  <div>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      placeholder="ex: 2000"
                      v-model="amount"
                      id="amount"
                      @keydown="blockInvalidAmountKeys"
                      @input="sanitizeAmount($event.target.value,$event.target)"
                    />
                  </div>
                </div>
                <div class="col-md-5" v-if="result==1">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transfers.link') }}</label>              
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" v-model="link" id="link" readonly />
                  </div>
                </div>
                <div class="col-md-1" style="padding-top: 2%;" v-if="result==1">
                  <a href="#" class="text-decoration-none" @click="copyToCliboard">                  
                    <label class="d-block text-black fw-semibold mb-10" style="visibility: hidden;">{{ $t('transfers.link') }}</label>      
                    <i class="flaticon-draft fs-6" style="color: #000"></i>                                  
                  </a>                                    
                </div>
              </div>
            </div>          
          </div>
          <div class="modal-footer">  
            <button class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0" type="button" @click="reset()">
              <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
              {{ $t('transfers.refresh') }}                
            </button>              
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" :disabled="!btnLoad" v-if="current_permissions('create_public_token')">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i> 
              {{ $t('transfers.generatePaymentLink') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Changer statut -->
  <div class="modal fade" id="changeStatusModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content edit-status-modal-content">
        <button type="button" class="btn-close status-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>

        <div class="edit-status-header">
          <div class="edit-status-icon">
            <i class="flaticon-pen"></i>
          </div>
          <h5 class="mb-0 mt-10">Modifier le statut</h5>
        </div>

        <div class="modal-body pt-10">
          <div class="edit-status-code-box mb-20">
            <span class="edit-status-code-label">Code transaction</span>
            <span class="edit-status-code-value">{{ changeStatusCheckoutId || '—' }}</span>
          </div>

          <div class="form-group mb-15">
            <label class="d-block text-black fw-semibold mb-10">
              Statut
            </label>
            <select v-model="newStatusValue" class="form-select fs-md-15 text-black shadow-none edit-status-select">
              <option value="OPEN">OPEN</option>
              <option value="COMPLETED">COMPLETED</option>
            </select>
          </div>

          <div class="form-group mb-15">
            <label class="d-block text-black fw-semibold mb-10">
              Statut de paiement
            </label>
            <select v-model="newPaymentStatusValue" class="form-select fs-md-15 text-black shadow-none edit-status-select">
              <option value="SUCCEEDED">SUCCEEDED</option>
              <option value="FAILED">FAILED</option>
              <option value="PENDING">PENDING</option>
              <option value="PROCESSING">PROCESSING</option>
              <option value="INITIATED">INITIATED</option>
              <option value="SCHEDULED">SCHEDULED</option>
            </select>
          </div>

          <div class="form-group mb-15">
            <label class="d-block text-black fw-semibold mb-10">
              Description <span class="text-muted fw-normal">(facultatif)</span>
            </label>
            <textarea
              v-model="newDescriptionValue"
              class="form-control fs-md-15 text-black shadow-none edit-status-select"
              rows="3"
              placeholder="Ajouter une description…"
            ></textarea>
          </div>

          <div class="form-group mb-5">
            <label class="d-block text-black fw-semibold mb-10">
              State <span class="text-muted fw-normal">(facultatif)</span>
            </label>
            <input
              v-model="newStateValue"
              type="number"
              min="0"
              max="5"
              step="1"
              class="form-control fs-md-15 text-black shadow-none edit-status-select"
              placeholder="0 à 5"
              @input="onStateInput"
            />
            <small v-if="stateError" class="text-danger fs-13">{{ stateError }}</small>
          </div>

          <p v-if="changeStatusError" class="text-danger fs-13 mt-10 mb-0">{{ changeStatusError }}</p>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Annuler</button>
          <button type="button" :disabled="!btnLoadStatus" class="btn edit-status-submit-btn" @click="submitChangeStatus()">
            <span v-if="!btnLoadStatus" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">Valider</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Statut réel de la transaction -->
  <div class="modal fade" id="transactionStatusModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content status-modal-content">
        <button type="button" class="btn-close status-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <div class="modal-body text-center p-0">
          <div v-if="statusLoading" class="status-loading">
            <span class="spinner-grow text-warning" role="status"></span>
            <p class="mt-15 mb-0 text-muted">Vérification en cours...</p>
          </div>
          <div v-else class="status-card">
            <div class="status-icon-wrap" :class="statusIconClass">
              <span v-if="statusDetails.paymentStatus==='SUCCEEDED' || statusDetails.paymentStatus==='SUCCESS'"></span>
              <span v-else-if="statusDetails.paymentStatus==='FAILED'"></span>
              <span v-else>⏳</span>
            </div>

            <h5 class="status-title mt-15 mb-5">{{ statusLabelText }}</h5>
            <p class="status-checkout-id mb-20">{{ statusDetails.payoutId || statusDetails.checkoutId }}</p>

            <div class="status-amount">
              {{ Number(statusDetails.amount || 0).toLocaleString() }} <span>F CFA</span>
            </div>

            <table class="status-table mt-20">
              <thead>
                <tr>
                  <th>Statut</th>
                  <th>Statut paiement</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span class="status-pill" :class="techStatusClass">{{ statusDetails.status || '—' }}</span>
                  </td>
                  <td>
                    <span class="status-pill" :class="paymentStatusClass">{{ statusDetails.paymentStatus || '—' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Receipt PDF -->
  <div ref="PDFReceipt" id="receipt" class="form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none">
    <div id="header_receipt">
      <h2 style="padding:2% 5% 2% 5%;color: #fff;">
        <span>
          <img src="../../../assets/images/i-money1.jpg" alt="logo-icon" style="max-width:10%;" />
          <span class="logo_text">IZYPAY</span>
        </span>
        <span id="header_text">{{ $t('transfers.transactionReceipt') }}</span>
      </h2>
    </div>
    <div id="body_receipt">
      <div id="arrow-top-section">
        <span id="arrow-top-left" class="section_content"><img src="../../../assets/images/arrowtopleft.svg" alt="logo-icon" style="min-width:3%;" /></span>
        <span id="arrow-top-right" class="section_content"><img src="../../../assets/images/arrowtopright.svg" alt="logo-icon" style="min-width:3%;" /></span>
      </div>
      <div id="body_first_section">
        <p v-if="transaction.clientId != ''"><span class="section_label">{{ $t('transfers.beneficiary') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ transaction.clientId }}</span></p>
        <p><span class="section_label">{{ $t('transfers.operator') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ operator }}</span></p>
        <p><span class="section_label">{{ $t('transfers.phone') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ transaction.contact }}</span></p>
        <p><span class="section_label">{{ $t('transfers.date') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ formatDateFr(new Date(transaction.transactionDate)) }}</span></p>
        <p style="margin-top: 10%;"><span class="section_label">{{ $t('transfers.transactionCode') }}</span><span class="section_content_other">{{ transaction.payoutId }}</span></p>
      </div>
      <div id="body_second_section">
        <p><span class="section_label">{{ $t('transfers.amountLabel') }}</span><span class="section_content_other1">{{ transaction.amount }} F</span></p>
        <p><span class="section_label">{{ $t('transfers.statusLabel') }}</span><span class="section_content_other1">{{ transaction.paymentStatus }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
      </div>
      <div id="body_third_section">
        <p><span class="section_label">{{ $t('transfers.thankYou') }}</span>&nbsp;&nbsp;<span class="section_content"><img src="../../../assets/images/imoji.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
      </div>
      <div id="arrow-bottom-section">
        <span id="arrow-bottom-left" class="section_content"><img src="../../../assets/images/arrowbottomleft.svg" alt="logo-icon" style="min-width:3%;" /></span>
        <span id="arrow-bottom-right" class="section_content"><img src="../../../assets/images/arrowbottomright.svg" alt="logo-icon" style="min-width:3%;" /></span>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, reactive, inject, nextTick, computed } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import { Modal } from 'bootstrap';
import router from '../../../router/index';
import { current_permissions } from '../../../utils/permission';
import { redirect } from '../../../utils/services';
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from 'intl-tel-input';
import { showToast, validate_phone_number, checkSessionValidate } from "@/utils/function";
import { Business, Transaction } from "@/utils/Model";

const PDFReceipt = ref<HTMLElement | null>(null);
let role: string | null = localStorage.getItem('role');

const isPrivilegedRole = role === 'SUPERADMIN' || role === 'BUSINESS' || role === 'SUPPORT';

const isSuperAdmin = role === 'SUPERADMIN';

const backApi = inject('back');
const frontApi = inject('front');
const { t } = useI18n();

let url = '';
let urlshow = backApi + '/secure/transactions';
if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
  url = backApi + '/secure/transactions/extended';
} else {
  url = backApi + '/secure/transactions';
}

const exportUrl = backApi + '/secure/transactions';

declare interface Organization {
  id: string;
  code: string;
  name: string;
  description: string;
  email: string;
  created_at: string;
}

declare interface Operator {
  id: string;
  code: string;
  mnoName: string;
  status: string;
  countryCode: string;
}

const businessMessage = ref('');
const business = ref(new Array<Business>());
const subBusiness = ref(new Array<Business>());
let businessTemp = new Array<Business>();
let iti: any;
const leadPlaceholder = "Select date";
const errors = ref('');
const errorId = ref('');
const errorsBis = { contact: '', amount: '', description: '', name: '' };
const formValues = reactive({
  contact: "",
  amount: "",
  description: "",
  name: ""
});

let codeOrganization: string | null = localStorage.getItem('organization_code');
const organization_name = localStorage.getItem('organization_name');
const email = localStorage.getItem('email');
let account_size = parseFloat(localStorage.getItem('account_size') + '');
let personnal_account_status = localStorage.getItem('personnal_account_status');

const schema = yup.object({
  contact: yup.string().required('Le numéro de téléphone est requis'),
  amount: yup.number()
    .typeError('Le montant doit être un nombre')
    .required('Le montant est requis')
    .moreThan(0, 'Le montant doit être supérieur à 0'),
  description: yup.string(),
  name: yup.string()
});

let data: any[] = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
let phone_number = ref('');

const token = localStorage.getItem('login_token');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const selectedPaymentStatus = ref('');
const selectedBusiness = ref(null);
const loader = ref(false);
const page = ref(1);
const total = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const paymentStatus = ref('');
const screenSelected = ref('');
const btnLoad = ref(true);
const btnLoad1 = ref(true);
const payoutBalance = ref(0);
let balance: number = 0;
let country_code = 'ci';
let phone_length = 0;
const transactions = ref(new Array<Transaction>());
const transaction1s = ref(new Array<Transaction>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
let operatorsTemp = new Array<Operator>();
const transaction = ref({} as Transaction);
let link = ref('');
let result = ref(0);
let selectedValidationType = ref('SIMPLE');

const exportEmpty = ref(false);

// Tous les filtres de Postman
const filterCheckoutId = ref('');
const filterPayoutId = ref('');
const filterAmount = ref('');
const filterUser = ref('');
const filterTransactionDate = ref('');
const filterCount = ref('');
const filterOrder = ref('');
const filterPlatform = ref('');

const changeStatusCheckoutId = ref('');
const newStatusValue = ref('');
const newPaymentStatusValue = ref('');
const btnLoadStatus = ref(true);
const changeStatusError = ref('');

const newDescriptionValue = ref('');
const newStateValue = ref('');
const stateError = ref('');

const statusDetails = ref<any>({});
const statusLoading = ref(false);

// ═══ Onglets actifs ═══
const activeFilterTab = ref<'base' | 'advanced'>('base');
const activeDetailTab = ref<'main' | 'advanced'>('main');

// ═══ Menu d'actions flottant ═══
const openMenuId = ref<string | null>(null);
const menuPosition = ref({ top: 0, left: 0 });
let menuOpenedAt = 0;

const currentMenuTransaction = computed(() => {
  if (!openMenuId.value) return null;
  return findTransactionInList(openMenuId.value) ?? null;
});

function toggleActionMenu(event: MouseEvent, payoutId: string) {
  if (openMenuId.value === payoutId) {
    closeActionMenu();
    return;
  }

  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();
  const menuWidth = 220;

  let left = rect.right - menuWidth;
  if (left < 8) left = 8;
  if (left + menuWidth > window.innerWidth - 8) {
    left = window.innerWidth - menuWidth - 8;
  }

  menuPosition.value = { top: rect.bottom + 4, left };
  openMenuId.value = payoutId;
  menuOpenedAt = Date.now();

  nextTick(() => {
    const menuEl = document.querySelector('.action-menu-fixed') as HTMLElement | null;
    if (!menuEl) return;
    const menuHeight = menuEl.offsetHeight;

    let top = rect.bottom + 4;
    if (top + menuHeight > window.innerHeight - 8) {
      top = rect.top - menuHeight - 4;
    }
    if (top < 8) top = 8;

    menuPosition.value = { ...menuPosition.value, top };
  });
}

function closeActionMenu() {
  openMenuId.value = null;
}

function handleGlobalClick(e: MouseEvent) {
  if (!openMenuId.value) return;
  const target = e.target as HTMLElement;
  if (target.closest('.action-menu-fixed') || target.closest('.dropdown-toggle')) {
    return;
  }
  closeActionMenu();
}

function handleGlobalScroll() {
  if (!openMenuId.value) return;
  if (Date.now() - menuOpenedAt < 300) return;
  closeActionMenu();
}

const isFilled = (v: any) => v !== '' && v !== null && v !== undefined;

const activeBaseFiltersCount = computed(() => {
  return [
    selectedOrganization.value,
    selectedOperator.value,
    selectedStatus.value,
    selectedPaymentStatus.value,
    beginDate.value,
    endDate.value,
    filterAmount.value,
    filterTransactionDate.value,
  ].filter(isFilled).length;
});

const activeAdvancedFiltersCount = computed(() => {
  return [
    filterCheckoutId.value,
    filterUser.value,
    filterCount.value,
    filterOrder.value,
    filterPlatform.value,
    phone_number.value,
    filterPayoutId.value,
  ].filter(isFilled).length;
});

function blockInvalidAmountKeys(event: KeyboardEvent) {
  if (['-', '+', 'e', 'E', ',', '.'].includes(event.key)) {
    event.preventDefault();
  }
}

function sanitizeAmountValue(value: string): number {
  let numericValue = (value || '').toString().replace(/[^0-9]/g, '');
  numericValue = numericValue.replace(/^0+(?=\d)/, '');
  return numericValue === '' ? 0 : parseInt(numericValue, 10);
}

function sanitizeAmount(value: string, tag: HTMLInputElement) {
  const parsed = sanitizeAmountValue(value);
  amount.value = parsed;
  tag.value = parsed === 0 ? '' : String(parsed);
}

function sanitizeSendMoneyAmount(value: string, tag: HTMLInputElement) {
  const parsed = sanitizeAmountValue(value);
  formValues.amount = parsed === 0 ? '' : String(parsed);
  tag.value = formValues.amount;
}

function sanitizeFilterAmount(value: string, tag: HTMLInputElement) {
  const parsed = sanitizeAmountValue(value);
  filterAmount.value = parsed === 0 ? '' : String(parsed);
  tag.value = filterAmount.value;
}

const onStateInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let val = input.value;

  val = val.replace(/[^0-9]/g, '');

  if (val.length > 1) {
    val = val.slice(0, 1);
  }

  if (val !== '' && parseInt(val, 10) > 5) {
    val = '5';
  }

  newStateValue.value = val;
  input.value = val;

  if (val === '') {
    stateError.value = '';
  } else if (parseInt(val, 10) > 5) {
    stateError.value = 'La valeur ne peut pas dépasser 5.';
  } else {
    stateError.value = '';
  }
};

function hasValue(value: any): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === '—' || trimmed === 'null' || trimmed === 'undefined') return false;
  }
  if (typeof value === 'number' && isNaN(value)) return false;
  return true;
}

function formatDateTimeFr(value: string | null | undefined): string {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

function formatDateFr(value: Date): string {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
  return '';
}

function formatDateEn(value: Date, d: number = 0): string {
  if (value) {
    const newDate = new Date(value);
    newDate.setDate(newDate.getDate() + d);

    const year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    const monthStr = month < 10 ? '0' + month : String(month);
    let day = newDate.getDate();
    const dayStr = day < 10 ? '0' + day : String(day);
    return year + '-' + monthStr + '-' + dayStr;
  }
  return '';
}

function truncateDescription(text: string, maxLength: number = 25): string {
  if (!text) return text;
  return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
}

function buildFilterParams(extra: Record<string, any> = {}) {
  const params = new URLSearchParams();

  const filters: Record<string, any> = {
    dateD: beginDate.value,
    dateF: endDate.value,
    count: filterCount.value,
    operator: selectedOperator.value,
    status: selectedStatus.value,
    paymentStatus: selectedPaymentStatus.value,
    amount: filterAmount.value,
    checkoutId: filterCheckoutId.value,
    transactionDate: filterTransactionDate.value,
    ordre: filterOrder.value,
    platform: filterPlatform.value,
    user: filterUser.value,
    organization: selectedOrganization.value,
    contact: phone_number.value,
    payoutId: filterPayoutId.value,
  };

  Object.assign(filters, extra);

  if (!isPrivilegedRole) {
    delete filters.checkoutId;
    delete filters.payoutId;
    delete filters.platform;
    delete filters.user;
    delete filters.ordre;
    delete filters.count;
    delete filters.contact;
  }

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== '') {
      params.append(key, value);
    }
  });

  return params.toString();
}

function buildExportParams(page: number) {
  const extra: Record<string, any> = {
    page,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  };

  if (endDate.value !== '') {
    extra.dateF = formatDateEn(new Date(endDate.value), 1);
  }

  return buildFilterParams(extra);
}

function resetFilters() {
  filterCheckoutId.value = '';
  filterPayoutId.value = '';
  filterAmount.value = '';
  filterUser.value = '';
  filterTransactionDate.value = '';
  filterCount.value = '';
  filterOrder.value = '';
  filterPlatform.value = '';
  selectedOrganization.value = '';
  selectedOperator.value = '';
  selectedStatus.value = '';
  selectedPaymentStatus.value = '';
  selectedBusiness.value = null;
  phone_number.value = '';
  beginDate.value = '';
  endDate.value = '';
  exportEmpty.value = false;

  const organizationEl = document.getElementById('organization') as HTMLSelectElement | null;
  if (organizationEl) organizationEl.value = '';
  const operatorEl = document.getElementById('operator') as HTMLSelectElement | null;
  if (operatorEl) operatorEl.value = '';
  const statusEl = document.getElementById('status') as HTMLSelectElement | null;
  if (statusEl) statusEl.value = '';
  const paymentStatusEl = document.getElementById('paymentStatus') as HTMLSelectElement | null;
  if (paymentStatusEl) paymentStatusEl.value = '';
}

function handlePhone(myvalue: string, tag: any) {
  country_code = iti.getSelectedCountryData().iso2;
  phone_length = 0;
  switch (country_code) {
    case 'ci':
      phone_length = parseInt(process.env.VUE_APP_CI_PHONE_LENTGH || '10');
      break;
    case 'sn':
      phone_length = parseInt(process.env.VUE_APP_SN_PHONE_LENTGH || '9');
      break;
    default:
      alert("Sélectionnez un pays");
  }
  validate_phone_number(myvalue, tag, phone_length);
}

function handleBusinessChange(event: any) {
  selectedBusiness.value = event.target.value;
  let temp = businessTemp.filter(item => item.code == selectedBusiness.value);
  if (temp.length > 0 && temp[0].validatePayoutBeforProcess == true) {
    businessMessage.value = "NB: cette catégorie nécessite toujours une validation d'un utilisateur autorisé";
  } else {
    businessMessage.value = "";
  }
  subBusiness.value = [];
  let businessArr = new Array<Business>();
  for (let j = 0; j < businessTemp.length; j++) {
    if (businessTemp[j].parent?.code == event.target.value) {
      businessArr.push(businessTemp[j]);
    }
  }
  if (businessArr.length > 0) {
    subBusiness.value = businessArr;
  }
}

function handleSubBusinessChange(event: any) {
  selectedBusiness.value = event.target.value;
  let temp = businessTemp.filter(item => item.code == selectedBusiness.value);
  if (temp.length > 0 && temp[0].validatePayoutBeforProcess == true) {
    businessMessage.value = "Cette catégorie nécessite toujours une validation d'un utilisateur autorisé";
  } else {
    businessMessage.value = "";
  }
}

function handleValidationTypeChange(event: any) {
  selectedValidationType.value = event.target.value;
}

function handleOrganizationChange(event: any) {
  selectedOrganization.value = event.target.value;
}

function handleOperatorChange(event: any) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event: any) {
  selectedStatus.value = event.target.value;
}

function handlePaymentStatusChange(event: any) {
  selectedPaymentStatus.value = event.target.value;
}

function initOperator(myvalue: string, tag: any) {
  country_code = iti.getSelectedCountryData().iso2;
  let operatorArr = new Array<Operator>();
  for (let j = 0; j < operatorsTemp.length; j++) {
    if (operatorsTemp[j].countryCode == country_code.toUpperCase()) {
      operatorArr.push(operatorsTemp[j]);
    }
  }
  operators.value = operatorArr;
}

onMounted(() => {
  checkSessionValidate(1);

  beginDate.value = formatDateEn(new Date());
  endDate.value = formatDateEn(new Date());

  if (account_size > 0 && personnal_account_status == "ACTIVE") {
    getTransfertBalancePerso();
  } else {
    getBalancePayout();
  }

  getTransactions();
  getOrganizations();
  getOperators();
  getBusiness();

  setTimeout(function () {
    flatpickr("#lead-calendar", {
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
      defaultDate: "today",
      enableTime: true,
    });
  }, 1000);

  const inputc = document.querySelector("#contact");
  iti = intlTelInput(inputc, {
    onlyCountries: ["ci", "sn"],
    initialCountry: "auto",
    geoIpLookup: function (callback) {
      fetch("https://ipapi.co/json")
        .then(function (res) { return res.json(); })
        .then(function (data) { callback(data.country_code); })
        .catch(function () { callback("ci"); });
    }
  });

  const statusModalEl = document.getElementById('transactionStatusModal');
  if (statusModalEl) {
    statusModalEl.addEventListener('hidden.bs.modal', handleStatusModalClosed);
  }

  document.addEventListener('click', handleGlobalClick);
  document.addEventListener('scroll', handleGlobalScroll, true);
});

onBeforeUnmount(() => {
  const statusModalEl = document.getElementById('transactionStatusModal');
  if (statusModalEl) {
    statusModalEl.removeEventListener('hidden.bs.modal', handleStatusModalClosed);
  }

  document.removeEventListener('click', handleGlobalClick);
  document.removeEventListener('scroll', handleGlobalScroll, true);
});

const usercode = localStorage.getItem('code');

const getBusiness = (arg: number = 1) => {
  let param = '';
  param = (role == 'SUPERADMIN') ? '' : `?organization=${codeOrganization}`;
  axios.get(backApi + '/secure/business/' + param, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      businessTemp = response.data;
      getBusinessParent(businessTemp);
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const getBusinessParent = (businessParents: any[]) => {
  let businessArr = new Array<Business>();
  for (let j = 0; j < businessParents.length; j++) {
    if (businessParents[j].parent == null) {
      businessArr.push(businessParents[j]);
    }
  }
  business.value = businessArr;
}

const getTransfertBalancePerso = () => {
  axios.post(backApi + '/secure/accounts/balance/main', {
    user: usercode,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      payoutBalance.value = response.data.balance;
      balance = response.data.balance;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          // router.push('/')
        }
      }
    });
}

const loadTransaction = (code: string) => {
  // Réinitialiser sur l'onglet principal
  activeDetailTab.value = 'main';

  axios.get(`${urlshow}/${code}/payout`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      transaction.value = response.data;
      operator.value = response.data.operator.mnoName;
      amount.value = response.data.amount.toLocaleString();
      paymentStatus.value = response.data.paymentStatus;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

function findTransactionInList(payoutId: string) {
  return transactions.value.find((t: any) => t.payoutId === payoutId)
      || transaction1s.value.find((t: any) => t.payoutId === payoutId);
}

function refreshCurrentList() {
  if (search.value) {
    searchTransaction(page.value);
  } else if (search1.value) {
    searchTransaction1({ target: {} }, page.value);
  } else {
    getTransactions(page.value);
  }
}

function handleStatusModalClosed() {
  refreshCurrentList();
}

function handleShowStatus(payoutId: string) {
  closeActionMenu();
  statusLoading.value = true;
  statusDetails.value = {};

  const modalEl = document.getElementById('transactionStatusModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();

  axios.get(`${backApi}/secure/transactions/${payoutId}/payout/status`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    const raw = response.data;
    statusDetails.value = Array.isArray(raw) ? (raw[0] ?? {}) : (raw ?? {});
    statusLoading.value = false;
  }).catch((error) => {
    statusLoading.value = false;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        showToast(error.response?.data?.message ?? "Erreur lors de la récupération du statut", "red");
      }
    }
  });
}

const isSuccessPaymentStatus = (value: string) => value === 'SUCCEEDED' || value === 'SUCCESS';
const isFailedPaymentStatus = (value: string) => value === 'FAILED';

const statusIconClass = computed(() => {
  if (isSuccessPaymentStatus(statusDetails.value.paymentStatus)) return 'status-icon-success';
  if (isFailedPaymentStatus(statusDetails.value.paymentStatus)) return 'status-icon-failed';
  return 'status-icon-pending';
});

const statusLabelText = computed(() => {
  if (isSuccessPaymentStatus(statusDetails.value.paymentStatus)) return 'Transaction réussie';
  if (isFailedPaymentStatus(statusDetails.value.paymentStatus)) return 'Transaction échouée';
  switch (statusDetails.value.paymentStatus) {
    case 'PROCESSING': return 'Transaction en cours';
    case 'PENDING': return 'Transaction en attente';
    default: return statusDetails.value.paymentStatus ? 'Statut : ' + statusDetails.value.paymentStatus : 'Statut inconnu';
  }
});

const techStatusClass = computed(() => statusDetails.value.status === 'COMPLETED' ? 'pill-completed' : 'pill-open');

const paymentStatusClass = computed(() => {
  if (isSuccessPaymentStatus(statusDetails.value.paymentStatus)) return 'pill-success';
  if (isFailedPaymentStatus(statusDetails.value.paymentStatus)) return 'pill-failed';
  return 'pill-pending';
});


/**
 * Retourne le libellé traduit d'un statut de paiement.
 */
function getPaymentStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  switch (status.toUpperCase()) {
    case 'SUCCEEDED':
    case 'SUCCESS':
      return t('transactions.success');
    case 'FAILED':
      return t('transactions.failed');
    case 'PROCESSING':
      return t('transactions.processing');
    case 'PENDING':
      return t('transactions.pending');
    case 'INITIATED':
      return t('transactions.initiated');
    case 'SCHEDULED':
      return t('transactions.scheduled');
    default:
      return status;
  }
}

function getPaymentStatusClass(status: string | null | undefined): string {
  if (!status) return 'badge text-outline-secondary';
  switch (status.toUpperCase()) {
    case 'SUCCEEDED':
    case 'SUCCESS':
      return 'badge text-outline-success';
    case 'FAILED':
      return 'badge text-outline-danger';
    case 'PROCESSING':
      return 'badge text-outline-info';
    case 'PENDING':
      return 'badge text-outline-warning';
    case 'INITIATED':
      return 'badge text-outline-primary';
    case 'SCHEDULED':
      return 'badge text-outline-secondary';
    default:
      return 'badge text-outline-secondary';
  }
}

function handleChangeStatus(payoutId: string) {
  closeActionMenu();
  const found = findTransactionInList(payoutId);

  changeStatusCheckoutId.value = (found as any)?.code ?? payoutId;

  newStatusValue.value = (found as any)?.status ?? '';
  newPaymentStatusValue.value = (found as any)?.paymentStatus ?? '';

  newDescriptionValue.value = (found as any)?.description ?? '';
  newStateValue.value = (found as any)?.state != null ? String((found as any).state) : '';
  stateError.value = '';

  changeStatusError.value = '';

  const modalEl = document.getElementById('changeStatusModal');
  if (modalEl) {
    Modal.getOrCreateInstance(modalEl).show();
  }
}

function submitChangeStatus() {
  changeStatusError.value = '';

  if (!changeStatusCheckoutId.value) {
    changeStatusError.value = "Le code de la transaction est requis.";
    return;
  }

  const payload: any = { code: changeStatusCheckoutId.value };
  if (newStatusValue.value) payload.status = newStatusValue.value;
  if (newPaymentStatusValue.value) payload.paymentStatus = newPaymentStatusValue.value;

  if (newDescriptionValue.value && newDescriptionValue.value.trim() !== '') {
    payload.description = newDescriptionValue.value.trim();
  }
  if (newStateValue.value !== '' && newStateValue.value !== null) {
    payload.state = parseInt(newStateValue.value, 10);
  }

  btnLoadStatus.value = false;

  axios.post(`${backApi}/secure/transactions/status`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadStatus.value = true;
    showToast("Statut mis à jour", "green");
    const modalEl = document.getElementById('changeStatusModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();

    if (search.value) {
      searchTransaction(page.value);
    } else if (search1.value) {
      searchTransaction1({ target: {} }, page.value);
    } else {
      getTransactions(page.value);
    }
  }).catch((error) => {
    btnLoadStatus.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
        showToast(error.response.data.message, "red");
      }
    }
  });
}

const getTransactions = (arg: number = 1) => {
  loader.value = false;
  gettran.value = true;
  search.value = false;
  search1.value = false;

  if (beginDate.value === '') {
    beginDate.value = formatDateEn(new Date());
  }
  if (endDate.value === '') {
    endDate.value = formatDateEn(new Date());
  }
  const todayE = formatDateEn(new Date(endDate.value), 1);

  const queryParams = buildFilterParams({
    page: arg,
    dateD: beginDate.value,
    dateF: todayE,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  });

  axios.get(`${url}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data.data;
      total.value = parseInt(response.data.pagination.total);
      page.value = parseInt(response.data.pagination.currentPage);
      numPages.value = parseInt(response.data.pagination.numPages);

      for (let pas = 0; pas < data.length; pas++) {
        data[pas].operator_name = data[pas].operator.mnoName;
        data[pas].description = truncateDescription(data[pas].description, 25);
      }
      transactions.value = data;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const getOrganizations = () => {
  axios.get(backApi + '/secure/organizations/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organizations.value = response.data;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const getOperators = () => {
  axios.get(backApi + '/secure/operators/available/' + process.env.VUE_APP_PAYOUT_OPTTYPE, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      operatorsTemp = response.data;
      operators.value = operatorsTemp.filter(
        (op) => op.countryCode === country_code.toUpperCase()
      );
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const exportExcel = () => {
  import("../../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE TRANSACTION", "OPERATEUR", "TELEPHONE", "MONTANT", "DATE", "STATUT"];
    const Fields = ["payoutId", "operator_name", "contact", "amount", "transactionDate", "paymentStatus"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "transactions",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData: string[], JsonData: any[]) {
  return JsonData.map((v) => FilterData.map((j) => {
    return v[j];
  }));
}

const searchTransactionExportToPDF = (): Promise<boolean> => {
  return new Promise((resolve) => {
    const queryParams = buildExportParams(1);

    axios.get(`${exportUrl}/list/export?${queryParams}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        if (response.status === 200) {
          const result = response.data;
          if (!result || result.length === 0) {
            transaction1s.value = [];
            exportEmpty.value = true;
            showToast("Aucune transaction trouvée pour ces critères, export impossible", "red");
            resolve(false);
            return;
          }
          exportEmpty.value = false;
          transaction1s.value = result;
          resolve(true);
        } else {
          resolve(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/');
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        resolve(false);
      });
  });
}

const exportToPDF = async () => {
  btnLoad1.value = false;

  const hasData = await searchTransactionExportToPDF();

  if (!hasData) {
    btnLoad1.value = true;
    return;
  }

  await nextTick();

  const tableElement = document.getElementById("transactionsTable");
  if (!tableElement) {
    btnLoad1.value = true;
    return;
  }

  tableElement.style.display = 'block';
  const opt = {
    margin: [0, 0, 0, 0],
    filename: "transactions.pdf",
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" }
  };

  html2pdf().set(opt).from(tableElement).toPdf().get('pdf').then(function (pdf) {
    window.open(pdf.output('bloburl'), '_blank');
    tableElement.style.display = 'none';
    btnLoad1.value = true;
  }).catch(() => {
    tableElement.style.display = 'none';
    btnLoad1.value = true;
  });
}

const searchTransaction = (arg: number = 1) => {
  loader.value = false;
  gettran.value = false;
  search.value = true;
  search1.value = false;

  if (beginDate.value === '') {
    beginDate.value = formatDateEn(new Date());
  }
  if (endDate.value === '') {
    endDate.value = formatDateEn(new Date(), 1);
  }
  const todayE = formatDateEn(new Date(endDate.value), 1);

  const queryParams = buildFilterParams({
    page: arg,
    dateD: beginDate.value,
    dateF: todayE,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  });

  axios.get(`${url}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data.data;
      total.value = parseInt(response.data.pagination.total);
      page.value = parseInt(response.data.pagination.currentPage);
      numPages.value = parseInt(response.data.pagination.numPages);
      for (let pas = 0; pas < data.length; pas++) {
        data[pas].operator_name = data[pas].operator.mnoName;
        data[pas].description = truncateDescription(data[pas].description, 25);
      }
      transactions.value = data;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const searchTransaction1 = (event: any, arg: number = 1) => {
  if (typeof event.target.value !== 'undefined') {
    today.value = event.target.value;
  }

  loader.value = false;
  gettran.value = false;
  search.value = false;
  search1.value = true;

  const todayE = formatDateEn(new Date(today.value), 1);

  const queryParams = buildFilterParams({
    page: arg,
    dateD: today.value,
    dateF: todayE,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  });

  axios.get(`${url}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data.data;
      total.value = parseInt(response.data.pagination.total);
      page.value = parseInt(response.data.pagination.currentPage);
      numPages.value = parseInt(response.data.pagination.numPages);
      for (let pas = 0; pas < data.length; pas++) {
        data[pas].operator_name = data[pas].operator.mnoName;
        data[pas].description = truncateDescription(data[pas].description, 25);
      }
      transactions.value = data;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const sendMoney = () => {
  btnLoad.value = false;

  const sendAmount = parseFloat(formValues.amount);

  if (sendAmount > 0 && sendAmount <= balance && selectedOperator.value !== '' && formValues.contact.length == phone_length) {
    try {
      schema.validateSync(formValues);
      axios.post(`${backApi}/secure/transactions/init`, {
        operator: selectedOperator.value,
        amount: formValues.amount,
        mobile: formValues.contact,
        operationType: parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE || '1'),
        countryCode: country_code,
        business: selectedBusiness.value,
        description: formValues.description,
        clientId: formValues.name,
        successUrl: "https://billing.api/success",
        errorUrl: "https://billing.api/error"
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        btnLoad.value = true;
        if (response.status === 201) {
          showToast("Transfert réussi", "green");
          formValues.amount = '';
          formValues.contact = '';
          selectedOperator.value = '';
          selectedBusiness.value = null;
        }
        router.go();
      }).catch((error) => {
        btnLoad.value = true;
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/');
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
      });
    } catch (error) {
      btnLoad.value = true;
      errors.value = "une erreur inattendue est apparue";
    }
  } else {
    if (isNaN(sendAmount) || sendAmount <= 0) {
      showToast("Veuillez saisir un montant correct", "red");
    }
    if (sendAmount > balance) {
      showToast("Solde insuffisant pour cette opération", "red");
    }
    if (selectedOperator.value == '') {
      showToast("Veuillez sélectionner un opérateur", "red");
    }
    if (formValues.contact.length != phone_length) {
      showToast("Veuillez saisir un numéro de téléphone correct", "red");
    }
    btnLoad.value = true;
  }
}

function validate(field: string) {
  schema.validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
}

const searchTransactionForExport = () => {
  btnLoad.value = false;

  const queryParams = buildExportParams(1);

  axios.get(`${exportUrl}/list/export?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        data = response.data;

        if (!data || data.length === 0) {
          exportEmpty.value = true;
          showToast("Aucune transaction trouvée pour ces critères, export impossible", "red");
          return;
        }

        exportEmpty.value = false;
        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator.mnoName;
        }
        exportExcel();
      }
    })
    .catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
}

const showScreen = (screen: string) => {
  screenSelected.value = screen;
  selectedBusiness.value = null;
  selectedOperator.value = '';
  selectedStatus.value = '';
  selectedPaymentStatus.value = '';
  exportEmpty.value = false;

  // Réinitialiser sur l'onglet principal
  activeFilterTab.value = 'base';

  if (screen === 'excel') {
    beginDate.value = '';
    endDate.value = '';
  }
}

const getBalancePayout = () => {
  axios.post(backApi + `/secure/accounts/balance/main`, {
    organization: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      payoutBalance.value = response.data.balance;
      balance = response.data.balance;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const generateLink = () => {
  errors.value = '';
  errorId.value = '';

  const linkAmount = parseFloat(amount.value as any);

  if (isNaN(linkAmount) || linkAmount <= 0) {
    showToast("Le montant doit être supérieur à 0", "red");
    errors.value = "Le montant doit être supérieur à 0";
    return;
  }

  if (linkAmount > balance) {
    showToast("Solde insuffisant pour générer ce lien de paiement", "red");
    errors.value = "Solde insuffisant pour générer ce lien de paiement";
    return;
  }

  btnLoad.value = false;

  try {
    axios.post(`${backApi}/secure/transactions/token`, {
      amount: amount.value,
      operationType: process.env.VUE_APP_PAYOUT_OPTTYPE,
      validationType: selectedValidationType.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 201) {
        link.value = response.data.ticketUrl;
        result.value = 1;
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue";
  }
}

function copyToCliboard() {
  var copyText = document.getElementById("link") as HTMLInputElement;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié", "green");
}

function copyToShare(publictoken: string) {
  let copyText = `${frontApi}/ticket/payout/${publictoken}`;
  navigator.clipboard.writeText(copyText);
  showToast("Lien copié avec succès", "green");
  closeActionMenu();
}

function reset() {
  amount.value = 0;
  link.value = '';
  result.value = 0;
  selectedValidationType.value = 'SIMPLE';
}

// ═══ Handlers du menu d'actions ═══
function handleView(payoutId: string) {
  loadTransaction(payoutId);
  closeActionMenu();
  activeDetailTab.value = 'main';
  const modalEl = document.getElementById('companyModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function handleReceipt(payoutId: string) {
  closeActionMenu();
  download_receipt(payoutId);
}

const download_receipt = (payoutId: string) => {
  loadTransaction(payoutId);

  const element = PDFReceipt.value;
  element?.classList.remove("d-none");

  document.getElementById("back")?.classList.add("d-none");
  setTimeout(() => {
    document.getElementById("receipt").style.display = 'block';

    const opt = {
      margin: [0, 0, 0, 0],
      filename: "receipt_" + transaction.value.payoutId + ".pdf",
      jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" },
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
    };
    html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().save();
  }, 3000);
  setTimeout(() => {
    element?.classList.add("d-none");
    document.getElementById("back")?.classList.remove("d-none");
  }, 3000);
}
</script>

<style scoped>
#title {
  text-decoration: underline;
  margin-bottom: 2%;
}
#subtitle {
  margin-bottom: 5%;
}
#headerRightText {
  padding-right: 2%;
  width: 50%;
  float: right;
  font-weight: bold;
}
#headerLeftText {
  padding-right: 2%;
  width: 50%;
  float: left;
  font-weight: bold;
}
#transactionsTable {
  display: none;
}
.tableHeader {
  font-size: 15px;
  padding: auto;
  font-weight: bold;
}
hr {
  border-top: 2px solid black;
  width: 100%;
  margin-top: 5%;
}
#tableLayout {
  border: 1px solid black;
}
#tableLayout td,
#tableLayout th {
  border: 1px solid black;
  font-size: 12px;
}
#sub_business,
#container_sub_business {
  display: none;
}
.table-responsive {
  overflow-x: auto;
}
.PDFReceipt.d-none {
  display: block !important;
  visibility: hidden;
}
#receipt {
  margin-top: 5px;
  border: 1px solid #706F6F;
  border-bottom: 1px solid #FFF;
  display: flex;
  flex-direction: column;
  width: 148mm;
}
#header_receipt {
  margin-top: -1%;
  background-color: #871728;
}
#logo_text {
  font-family: gruppo;
}
#header_text {
  font-size: 70%;
  float: inline-end;
  margin-top: 3%;
}
#arrow-top-left {
  margin-left: 12%;
}
#arrow-top-right {
  margin-left: 70%;
}
#arrow-bottom-left {
  margin-left: 12%;
}
#arrow-bottom-right {
  margin-left: 70%;
}
#body_receipt {
  display: flex;
  flex-direction: column;
  padding-top: 15%;
  width: 100%;
}
#body_first_section {
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_second_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_third_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
.section_label {
  font-size: 100%;
  font-weight: bold;
}
.section_content_other {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 1%;
  padding: 5px 15px 5px 15px;
}
.section_content_other1 {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

.modal-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}

.modal-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: #777;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: color .15s ease, border-color .15s ease;
  font-family: inherit;
  white-space: nowrap;
}

.modal-tab:hover:not(.active) {
  color: #EB9355;
}

.modal-tab.active {
  color: #EB9355;
  border-bottom-color: #EB9355;
}

.tab-badge {
  background: #282523;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 10px;
  padding: 0 6px;
}

.modal-tab.active .tab-badge {
  background: #EB9355;
}

@media (max-width: 576px) {
  .modal-tab {
    padding: 12px 10px;
    font-size: 13px;
  }
}

#companyModal .modal-body {
  max-height: 75vh;
  overflow-y: auto;
}

.status-modal-content {
  border-radius: 18px;
  border: none;
  overflow: hidden;
  padding-top: 10px;
  position: relative;
}
.status-modal-close {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 5;
}
.status-loading {
  padding: 50px 20px;
}
.status-card {
  padding: 35px 25px 20px 25px;
}
.status-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 32px;
  font-weight: bold;
  color: #fff;
}
.status-icon-success {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  box-shadow: 0 8px 20px rgba(39, 174, 96, .35);
}
.status-icon-failed {
  background: linear-gradient(135deg, #ff6b6b, #e74c3c);
  box-shadow: 0 8px 20px rgba(231, 76, 60, .35);
}
.status-icon-pending {
  background: linear-gradient(135deg, #f7b733, #EB9355);
  box-shadow: 0 8px 20px rgba(235, 147, 85, .35);
}
.status-title {
  font-weight: 700;
  color: #222;
}
.status-checkout-id {
  font-size: 13px;
  color: #999;
  letter-spacing: .3px;
}
.status-amount {
  font-size: 34px;
  font-weight: 800;
  color: #861727;
}
.status-amount span {
  font-size: 14px;
  font-weight: 600;
  color: #999;
  margin-left: 4px;
}
.status-table {
  width: 100%;
  border-collapse: collapse;
}
.status-table th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: #999;
  font-weight: 700;
  padding: 0 8px 10px 8px;
  text-align: center;
  border-bottom: 1px solid #eee;
}
.status-table td {
  padding: 14px 8px 0 8px;
  text-align: center;
  vertical-align: middle;
}
.status-pill {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .5px;
  text-transform: uppercase;
}
.pill-completed { background: #e8f8ee; color: #27ae60; }
.pill-open { background: #fff4e5; color: #EB9355; }
.pill-success { background: #e8f8ee; color: #27ae60; }
.pill-failed { background: #fdecea; color: #e74c3c; }
.pill-pending { background: #fff4e5; color: #EB9355; }

.edit-status-modal-content {
  border-radius: 18px;
  border: none;
  overflow: hidden;
  position: relative;
}
.edit-status-header {
  text-align: center;
  padding: 30px 25px 15px 25px;
  background: linear-gradient(135deg, #fff6ee, #ffffff);
}
.edit-status-icon {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: linear-gradient(135deg, #f7b733, #EB9355);
  color: #fff;
  font-size: 22px;
  box-shadow: 0 8px 18px rgba(235, 147, 85, .35);
}
.edit-status-header h5 {
  font-weight: 700;
  color: #222;
}
.edit-status-code-box {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #faf7f5;
  border: 1px solid #f0e6de;
  border-radius: 12px;
  padding: 12px 16px;
}
.edit-status-code-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: #b98a63;
  font-weight: 700;
}
.edit-status-code-value {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  word-break: break-all;
}
.edit-status-select {
  border-radius: 10px;
}
.edit-status-submit-btn {
  background-color: #EB9355;
  border-radius: 10px;
  padding: 8px 22px;
}

.edit-status-submit-btn:hover {
    background-color: #3d7e24;
    border-color: #f5b800;
    color: #fff;
}


#changeStatusModal .modal-dialog {
  max-width: 400px;
  width: 90%;
}

#changeStatusModal .modal-content {
  border-radius: 12px;
}

.action-menu-fixed {
  position: fixed;
  z-index: 2000;
  min-width: 200px;
  max-width: calc(100vw - 20px);
  max-height: calc(100vh - 20px);
  overflow-y: auto;
  display: block;
  pointer-events: auto;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 6px 0;
}
</style>